function d(o, e, t) {
  return typeof o === e ? () => o : typeof o == "function" ? o : t;
}
class m {
  constructor(e, { direction: t, elementEnterAction: r, elements: s, focusInIndex: c, isFocusableElement: l, listenerScope: u } = { elements: () => [] }) {
    this._currentIndex = -1, this.prevIndex = -1, this._direction = () => "both", this.directionLength = 5, this.elementEnterAction = (n) => {
    }, this._focused = !1, this._focusInIndex = (n) => 0, this.isFocusableElement = (n) => !0, this._listenerScope = () => this.host, this.offset = 0, this.recentlyConnected = !1, this.handleFocusin = (n) => {
      if (!this.isEventWithinListenerScope(n)) return;
      const i = n.composedPath();
      let h = -1;
      i.find((a) => (h = this.elements.indexOf(a), h !== -1)), this.prevIndex = this.currentIndex, this.currentIndex = h > -1 ? h : this.currentIndex, this.isRelatedTargetOrContainAnElement(n) && this.hostContainsFocus();
    }, this.handleClick = () => {
      var n;
      const i = this.elements;
      if (!i.length) return;
      let h = i[this.currentIndex];
      this.currentIndex < 0 || ((!h || !this.isFocusableElement(h)) && (this.setCurrentIndexCircularly(1), h = i[this.currentIndex]), h && this.isFocusableElement(h) && ((n = i[this.prevIndex]) == null || n.setAttribute("tabindex", "-1"), h.setAttribute("tabindex", "0")));
    }, this.handleFocusout = (n) => {
      this.isRelatedTargetOrContainAnElement(n) && this.hostNoLongerContainsFocus();
    }, this.handleKeydown = (n) => {
      if (!this.acceptsEventCode(n.code) || n.defaultPrevented) return;
      let i = 0;
      switch (this.prevIndex = this.currentIndex, n.code) {
        case "ArrowRight":
          i += 1;
          break;
        case "ArrowDown":
          i += this.direction === "grid" ? this.directionLength : 1;
          break;
        case "ArrowLeft":
          i -= 1;
          break;
        case "ArrowUp":
          i -= this.direction === "grid" ? this.directionLength : 1;
          break;
        case "End":
          this.currentIndex = 0, i -= 1;
          break;
        case "Home":
          this.currentIndex = this.elements.length - 1, i += 1;
      }
      n.preventDefault(), this.direction === "grid" && this.currentIndex + i < 0 ? this.currentIndex = 0 : this.direction === "grid" && this.currentIndex + i > this.elements.length - 1 ? this.currentIndex = this.elements.length - 1 : this.setCurrentIndexCircularly(i), this.elementEnterAction(this.elements[this.currentIndex]), this.focus();
    }, this.mutationObserver = new MutationObserver(() => {
      this.handleItemMutation();
    }), this.host = e, this.host.addController(this), this._elements = s, this.isFocusableElement = l || this.isFocusableElement, this._direction = d(t, "string", this._direction), this.elementEnterAction = r || this.elementEnterAction, this._focusInIndex = d(c, "number", this._focusInIndex), this._listenerScope = d(u, "object", this._listenerScope);
  }
  get currentIndex() {
    return this._currentIndex === -1 && (this._currentIndex = this.focusInIndex), this._currentIndex - this.offset;
  }
  set currentIndex(e) {
    this._currentIndex = e + this.offset;
  }
  get direction() {
    return this._direction();
  }
  get elements() {
    return this.cachedElements || (this.cachedElements = this._elements()), this.cachedElements;
  }
  set focused(e) {
    e !== this.focused && (this._focused = e);
  }
  get focused() {
    return this._focused;
  }
  get focusInElement() {
    return this.elements[this.focusInIndex];
  }
  get focusInIndex() {
    return this._focusInIndex(this.elements);
  }
  isEventWithinListenerScope(e) {
    return this._listenerScope() === this.host || e.composedPath().includes(this._listenerScope());
  }
  handleItemMutation() {
    if (this._currentIndex == -1 || this.elements.length <= this._elements().length) return;
    const e = this.elements[this.currentIndex];
    if (this.clearElementCache(), this.elements.includes(e)) return;
    const t = this.currentIndex !== this.elements.length, r = t ? 1 : -1;
    t && this.setCurrentIndexCircularly(-1), this.setCurrentIndexCircularly(r), this.focus();
  }
  update({ elements: e } = { elements: () => [] }) {
    this.unmanage(), this._elements = e, this.clearElementCache(), this.manage();
  }
  focus(e) {
    var t;
    const r = this.elements;
    if (!r.length) return;
    let s = r[this.currentIndex];
    (!s || !this.isFocusableElement(s)) && (this.setCurrentIndexCircularly(1), s = r[this.currentIndex]), s && this.isFocusableElement(s) && ((t = r[this.prevIndex]) == null || t.setAttribute("tabindex", "-1"), s.tabIndex = 0, s.focus(e));
  }
  clearElementCache(e = 0) {
    this.mutationObserver.disconnect(), delete this.cachedElements, this.offset = e, requestAnimationFrame(() => {
      this.elements.forEach((t) => {
        this.mutationObserver.observe(t, { attributes: !0 });
      });
    });
  }
  setCurrentIndexCircularly(e) {
    const { length: t } = this.elements;
    let r = t;
    this.prevIndex = this.currentIndex;
    let s = (t + this.currentIndex + e) % t;
    for (; r && this.elements[s] && !this.isFocusableElement(this.elements[s]); ) s = (t + s + e) % t, r -= 1;
    this.currentIndex = s;
  }
  hostContainsFocus() {
    this.host.addEventListener("focusout", this.handleFocusout), this.host.addEventListener("keydown", this.handleKeydown), this.focused = !0;
  }
  hostNoLongerContainsFocus() {
    this.host.addEventListener("focusin", this.handleFocusin), this.host.removeEventListener("focusout", this.handleFocusout), this.host.removeEventListener("keydown", this.handleKeydown), this.focused = !1;
  }
  isRelatedTargetOrContainAnElement(e) {
    const t = e.relatedTarget, r = this.elements.includes(t), s = this.elements.some((c) => c.contains(t));
    return !(r || s);
  }
  acceptsEventCode(e) {
    if (e === "End" || e === "Home") return !0;
    switch (this.direction) {
      case "horizontal":
        return e === "ArrowLeft" || e === "ArrowRight";
      case "vertical":
        return e === "ArrowUp" || e === "ArrowDown";
      case "both":
      case "grid":
        return e.startsWith("Arrow");
    }
  }
  manage() {
    this.addEventListeners();
  }
  unmanage() {
    this.removeEventListeners();
  }
  addEventListeners() {
    this.host.addEventListener("focusin", this.handleFocusin), this.host.addEventListener("click", this.handleClick);
  }
  removeEventListeners() {
    this.host.removeEventListener("focusin", this.handleFocusin), this.host.removeEventListener("focusout", this.handleFocusout), this.host.removeEventListener("keydown", this.handleKeydown), this.host.removeEventListener("click", this.handleClick);
  }
  hostConnected() {
    this.recentlyConnected = !0, this.addEventListeners();
  }
  hostDisconnected() {
    this.mutationObserver.disconnect(), this.removeEventListeners();
  }
  hostUpdated() {
    this.recentlyConnected && (this.recentlyConnected = !1, this.elements.forEach((e) => {
      this.mutationObserver.observe(e, { attributes: !0 });
    }));
  }
}
export {
  m as F
};
//# sourceMappingURL=FocusGroup-CysiCtsR.js.map
